import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import angularGettext from 'angular-gettext';
import MediaPageModule from './MediaPageDirective'
import './mediaPage.scss';

let dashboardModule = angular.module('cms.pages.media', [
    uiRouter,
    angularGettext,
    MediaPageModule
])
    .config(routeConfig);

function routeConfig($stateProvider, gettext) {
    /** @ngInject */
    $stateProvider
        .state('media', {
            url: '/media',
            component: 'mediaPageView',
            title: gettext('Media library'),
            data: {
                requiresAuth: ['ROLE_ADMIN','ROLE_USER']
            },
            sidebarMeta: {
                icon: 'ion-image',
                order: 0,
                allow: ['ROLE_ADMIN','ROLE_USER']
            },
        });
}


export default dashboardModule.name;


// WEBPACK FOOTER //
// ./src/cmsPages/Media/MediaPageModule.js